const POPOVER_CONTAINER_PADDING = 2;
export default POPOVER_CONTAINER_PADDING;
